export const MIN_DESKTOP_PX = 768;

// Samme konstant-verdi brukes i /src/styles/_constants.scss
// Skal denne endres, må den endres begge steder.
